import gql from 'graphql-tag';
import { EVENT_FRAGMENT } from './event';

export const HANDLE = gql`
  ${EVENT_FRAGMENT}
  query Handle($handle: String!) {
    handle(handle: $handle) {
      __typename
      ... on Event {
        ...EventFragment
      }
    }
  }
`;
